document.addEventListener('DOMContentLoaded', () => {
  const input = document.querySelector('.site-header__search-input');
  if (!input) return;

  const dataEl = document.getElementById('search-terms-data');
  if (!dataEl) return;

  let searchTerms = [];
  try {
    const parsed = JSON.parse((dataEl.textContent || '').trim());
    if (Array.isArray(parsed)) {
      // In case you switch back to array output later
      searchTerms = parsed;
    } else if (typeof parsed === 'string') {
      // Your current setup: a single multiline string -> split into lines
      searchTerms = parsed.split(/\r?\n/).map(s => s.trim()).filter(Boolean);
    }
  } catch (e) {
    // malformed JSON, bail
    return;
  }

  if (!searchTerms.length) return;

  let termIndex = 0, charIndex = 0, deleting = false;

  function type() {
    const current = searchTerms[termIndex];

    if (!deleting) {
      input.placeholder = current.slice(0, ++charIndex);
      if (charIndex === current.length) {
        deleting = true;
        setTimeout(type, 1500);
        return;
      }
    } else {
      input.placeholder = current.slice(0, --charIndex);
      if (charIndex === 0) {
        deleting = false;
        termIndex = (termIndex + 1) % searchTerms.length;
      }
    }
    setTimeout(type, deleting ? 50 : 100);
  }

  type();
});
